import { MRT_ColumnDef, MRT_RowData } from "material-react-table";
import {
  CustomSearch,
  EstadoComponente,
  GeneralTable,
 SampleTable, SingleButton } from "@/shared/components/ui";
import { useGetSolicitudesIngreso } from "@/shared/actions/erp";
import { useCheckPermissions, useTableFilter } from "@/shared/hooks";
import {
  EstadosSolicitudIngresoEnum,
  SolicitudesIngreso,
} from "@/shared/interfaces";
import { Grid } from "@mui/material";
import { useMemo, useState } from "react";
import { ScrollableDialogProps } from "@/shared/components/ui/Dialogs";

import VisibilityIcon from "@mui/icons-material/Visibility";
import { IUbicacionProducto } from "@/shared/interfaces/erp/inventario";
import { PermissionsEnum } from "@/auth/interfaces";

export default function SolicitudIngresoBodegaRechazadosPagina() {
  useCheckPermissions(PermissionsEnum.api_add_solicitudingreso);

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [details, setDetails] = useState<IUbicacionProducto[]>([]);

  const columns = useMemo<MRT_ColumnDef<SolicitudesIngreso>[]>(
    () => [
      {
        accessorKey: "detalle",
        header: "Detalle",
        size: 200,
        Cell: ({ row }) => {
          return (
            <SingleButton
              label="ver"
              variant="text"
              color="success"
              onClick={() => onDetails(row.original)}
              startIcon={<VisibilityIcon />}
            />
          );
        },
      },
      {
        accessorKey: "fecha_creacion",
        header: "fecha solicitud",
        size: 200,
      },
      {
        accessorKey: "numero_referencia",
        header: "numero referencia",
        size: 200,
      },
      {
        accessorKey: "bodega",
        header: "bodega",
        size: 200,
      },
      {
        accessorKey: "observaciones",
        header: "observaciones",
        size: 200,
      },
      {
        accessorKey: "unidad_transporte",
        header: "unidad transporte",
        size: 200,
      },
      {
        accessorKey: "ubicacion",
        header: "ubicacion",
        size: 200,
      },
      {
        accessorKey: "user.username",
        header: "Usuario",
        size: 200,
      },
      {
        accessorKey: "estado_solicitud",
        header: "estado",
        size: 200,
        Cell: ({ row }) =>
          row.original.estado_solicitud != null ? (
            <EstadoComponente
              backgroundColor="red"
              texto={row.original.estado_solicitud || ""}
            />
          ) : null,
      },
    ],
    []
  );

  const onDetails = (e: MRT_RowData) => {
    setDetails(JSON.parse(e.detalle));
    setIsModalOpen(true);
  };
  const columnsProductosDetallePedidosDb: MRT_ColumnDef<IUbicacionProducto>[] =
    useMemo<MRT_ColumnDef<IUbicacionProducto>[]>(
      () => [
        {
          accessorKey: 'codigo',
          header: 'Código',
          Cell: ({ row }) => row.original?.codigo || 'N/A',
        },
        {
          accessorKey: 'descripcion',
          header: 'Descripción',
          Cell: ({ row }) => row.original?.producto_data?.descripcion || 'N/A',
        },

        {
          accessorKey: 'stock_actual',
          header: 'Stock Actual',
          // stock_actual = cantidad transferida
          Cell: ({ row }) => row.original?.producto_data?.stock_actual ?? 'N/A',
        },
        {
          accessorKey: 'producto_data.modelo_producto',
          header: 'Modelo',
        },
        {
          accessorKey: 'producto_data.marca_producto',
          header: 'Marca',
        },
        {
          accessorKey: 'producto_data.categoria_producto',
          header: 'Categoria',
        },
        {
          accessorKey: 'producto_data.unidad_medida',
          header: 'Medida',
        },
      ],
      []
    );

  const {
    globalFilter,
    pagination,
    searchTerm,
    onChangeFilter,
    setPagination,
    dateBefore,
    dateAfter,
    onChangeRangeDate,
    cleanFilter,

  } = useTableFilter();

  const { pageIndex } = pagination;

  const {
    data: solicitudPedidoIngresosRechazadosRes,
    isLoading,
    isRefetching,
  } = useGetSolicitudesIngreso({
    page_size: 600,
    page: pageIndex + 1,
    estado_solicitud: EstadosSolicitudIngresoEnum.RECHAZADO,
    fecha_after: dateAfter,
    fecha_before: dateBefore,
    numero_referencia: searchTerm,
  });
  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <CustomSearch
          onChange={onChangeFilter}
          value={globalFilter}
          text=""
          onChangeRangeDate={onChangeRangeDate}
          cleanFilter={cleanFilter}
        />
      </Grid>
      <Grid item xs={12}>
        <GeneralTable<SolicitudesIngreso>
          columns={columns}
          data={solicitudPedidoIngresosRechazadosRes?.data.data || []}
          //
          isLoading={isLoading}
          isRefetching={isRefetching}
          // // search
          enableGlobalFilter={false}
          // onGlobalFilterChange={setGlobalFilter}
          // // pagination
          pagination={pagination}
          onPaging={setPagination}
          rowCount={solicitudPedidoIngresosRechazadosRes?.data?.count}
          // // actions
          actionsColumnSize={120}
          // crud
          enableColumnActions={false}
          enableEditing={false}
          canDelete={false}
          positionActionsColumn="first"
        />
      </Grid>
      <ScrollableDialogProps
        open={isModalOpen}
        title="Detalles"
        cancelTextBtn="Cerrar"
        onClose={() => setIsModalOpen(false)}
        minWidth="100%"
        contentNode={
          <Grid container spacing={3}>
            <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
              {details.length > 0 && (
                <SampleTable<IUbicacionProducto>
                  columns={columnsProductosDetallePedidosDb}
                  data={details}
                />
              )}
            </Grid>
          </Grid>
        }
      />
    </Grid>
  );
}
